module.exports = __webpack_public_path__ + "img/p4only.cf4907d1.png";